export default "__VITE_ASSET__Dw0LVaa0__"